export default __webpack_public_path__ + "static/media/magento-logo.4724343a.svg";